import React, { useEffect } from 'react'

import { useToggle, useLoading, useModal } from 'hooks'
import useAuth from 'hooks/useAuth'
import {
  ChangePasswordModal,
  PasswordProps
} from 'pages/Login/components/ChangePasswordModal/ChangePasswordModal'
import { useHistory, useLocation } from 'react-router-dom'
import { UserServices } from 'services/Supplier/Users'
import useApp from 'hooks/useApp'

const BlankPage: React.FC = () => {
  const { replace } = useHistory()
  const location = useLocation<any>()
  const { showModal } = useModal()
  const { setTitlePage } = useApp()

  const { user, usuarioFornecedor, logout } = useAuth()
  const { setLoading, setMsgErro, setMsgSucesso, toggleSucessShow } =
    useLoading()
  const [isChangePassword, toggleChangePassword] = useToggle(false)
  const handleChangePassword = async (data: PasswordProps) => {
    setLoading('loading')
    try {
      const response = await UserServices().changePassword({
        email: user.TxEmail,
        newPassword: data.newPassword
      })

      if (!response.data.sucesso) throw new Error(response.data.mensagem)

      toggleChangePassword()
      setMsgSucesso(
        response.data.mensagem
          ? response.data.mensagem
          : 'Senha alterada com sucesso.'
      )
      toggleSucessShow()
      setLoading('idle')
    } catch (error: any) {
      let msgErro: string
      if (error.mensagem) msgErro = error.mensagem
      setMsgErro(msgErro || 'Não foi possivel alterar senha')
      setLoading('error')
    }
  }

  useEffect(() => {
    if (usuarioFornecedor?.FlPrimeiroAcesso) toggleChangePassword()
  }, [usuarioFornecedor])

  useEffect(() => {
    setTitlePage(null)
  }, [])

  //SERVE SOMENTE PARA TER UMA PAGINA EM BRANCO DEPOIS QUE LOGAR

  useEffect(() => {
    if (location?.state?.noAcess) {
      showModal({
        handleConfirm: () => replace(location?.state?.from, {}),
        hideButtonCancel: true,
        message: 'Acesso não permitido. Entre contato com administrador.',
        txtButtonConfirm: 'Fechar',
        type: 'alert'
      })
    }
  }, [location])
  return (
    <>
      {!!isChangePassword && (
        <ChangePasswordModal
          open={isChangePassword}
          handleClose={() => {
            toggleChangePassword()
            logout()
          }}
          handleChangePassword={handleChangePassword}
        />
      )}
    </>
  )
}

export default BlankPage
